
export default function HeroSection() {
  const handleScroll = (href: string) => {
    const element = document.querySelector(href);
    if (element) {
      const offset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  return (
    <section id="home" className="relative min-h-screen flex items-center overflow-hidden bg-gradient-to-br from-[#E8F4F8] via-[#F0F9FF] to-[#FFFFFF] pt-20">
      {/* 背景装飾 */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute top-0 right-0 w-1/2 h-full opacity-20">
          <div className="absolute top-1/4 right-1/4 w-96 h-96 bg-gradient-to-br from-[#4A90E2] to-[#50C9C3] rounded-full blur-3xl"></div>
          <div className="absolute bottom-1/4 right-1/3 w-80 h-80 bg-gradient-to-br from-[#50C9C3] to-[#4A90E2] rounded-full blur-3xl"></div>
        </div>
      </div>

      <div className="max-w-[1400px] mx-auto px-10 py-20 relative z-10">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* 左側コンテンツ */}
          <div className="space-y-12">
            {/* ロゴ */}
            <div className="animate-fade-in">
              <img
                src="https://static.readdy.ai/image/69410fb2e6bcdd872737f1aa8d7dee35/baf478bf3cc0ca3183d92ef9021d5d79.jpeg"
                alt="未来ウェルビーイング協会"
                className="w-80 max-w-full h-auto"
              />
            </div>

            {/* メインキャッチコピー */}
            <h1 className="text-5xl lg:text-6xl font-bold leading-tight text-[#1A2B3C] animate-fade-in-up" style={{ animationDelay: '0.2s' }}>
              人と社会、<br />
              そしてペットの<br />
              <span className="bg-gradient-to-r from-[#4A90E2] to-[#50C9C3] bg-clip-text text-transparent">
                しあわせな未来
              </span>
              を、<br />
              デザインする
            </h1>

            {/* サブコピー */}
            <p className="text-lg leading-relaxed text-[#5A6C7D] max-w-xl animate-fade-in-up" style={{ animationDelay: '0.4s' }}>
              個人の健康から、組織・地域・社会のしあわせな循環へ。<br />
              未来ウェルビーイング協会は、ボディスキャンや光美容、<br />
              ペットとの共生プログラムなどを通じて、<br />
              新しい時代のウェルビーイングをカタチにします。
            </p>

            {/* CTAボタン */}
            <div className="flex flex-col sm:flex-row gap-5 animate-fade-in-up" style={{ animationDelay: '0.6s' }}>
              <button
                onClick={() => handleScroll('#about')}
                className="h-14 px-8 bg-gradient-to-r from-[#4A90E2] to-[#50C9C3] text-white text-base font-semibold rounded-full hover:shadow-xl transition-all duration-300 hover:scale-105 whitespace-nowrap cursor-pointer"
              >
                協会について詳しく見る
              </button>
              <button
                onClick={() => handleScroll('#contact')}
                className="h-14 px-8 bg-white border border-gray-300 text-[#1A2B3C] text-base font-semibold rounded-full hover:bg-[#E8F4F8] transition-all duration-300 flex items-center justify-center gap-2 whitespace-nowrap cursor-pointer"
              >
                お問い合わせ・ご相談
                <i className="ri-arrow-right-line"></i>
              </button>
            </div>
          </div>

          {/* 右側画像 */}
          <div className="relative animate-fade-in" style={{ animationDelay: '0.3s' }}>
            <div className="relative rounded-[32px] overflow-hidden shadow-2xl">
              <div className="aspect-[4/5] w-full h-full">
                <img
                  src="https://public.readdy.ai/ai/img_res/fdd663524dce23e2a67a542070c17015.jpg"
                  alt="人とペットの共生"
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="absolute bottom-0 left-0 right-0 h-32 bg-gradient-to-t from-white/90 to-transparent flex items-end justify-center pb-6">
                <p className="text-sm font-medium text-[#1A2B3C]">人とペットの共生社会へ</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* スクロール誘導 */}
      <div className="absolute bottom-10 left-1/2 -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-3xl text-[#4A90E2]"></i>
      </div>

      <style>{`
        @keyframes fade-in {
          from { opacity: 0; }
          to { opacity: 1; }
        }
        @keyframes fade-in-up {
          from {
            opacity: 0;
            transform: translateY(30px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        .animate-fade-in {
          animation: fade-in 1s ease-out forwards;
        }
        .animate-fade-in-up {
          animation: fade-in-up 1s ease-out forwards;
          opacity: 0;
        }
      `}</style>
    </section>
  );
}
